import { Box, Typography } from "@mui/material";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { stepsProcess } from "../../../../constants/Devolve/stepsProcess";
import { colors } from "../../../../styles/Variables";

const CashBackProcess = () => {
    return (
        <Box
        sx={{
            backgroundColor: "#F4CC3B",
            py: { xs: 6, md: 4 },
            textAlign: "center",
            height: { xs: 'auto', md: '350px' },
            mb: 8,
        }}
        >
        <Typography
            variant="h5"
            sx={{
            fontWeight: "bold",
            color: colors.purple,
            fontSize: { xs: "1.2rem", md: "1.8rem", sm: "1.5rem" },
            mb: { xs: 4, md: 6 },
            }}
        >
            COMO FUNCIONA O MEUCUPOM DEVOLVE
        </Typography>

        <Box
            sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row", sm: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 4, md: 6 },
            }}
        >
            {stepsProcess.map((step, index) => (
            <Box
                key={index}
                sx={{
                display: "flex",
                flexDirection: { xs: "row", md: "column", sm: "column" },
                alignItems: "center",
                maxWidth: { xs: '100%', md: 220, sm: 220 },
                minHeight: { xs: 'auto', md: 290, sm: 290 },
                px: 2,
                }}
            >
                <Box
                component="img"
                src={step.icon}
                alt={`Passo ${index + 1}`}
                sx={{ 
                width: { xs: '160px', sm: '200px', md: '200px' } , 
                mb: { xs: 0, md: 2, sm: 2} 
            }}
                />
                <Typography
                sx={{
                    fontSize: "0.95rem",
                    fontWeight: "400",
                    color: colors.purple,
                }}
                >
                {step.text}
                </Typography>
            </Box>
            ))}
            <Box
            sx={{
                position: "absolute",
                display: { xs: "none", md: "flex", sm: "flex" },
                gap: 2,
                mx: 2,
                mt: -12,
            }}
            >
            {[0, 1].map((_, i) => (
                <Box key={i} sx={{ px: 14, display: "flex", alignItems: "center" }}>
                <DoubleArrowIcon sx={{ fontSize: 66, color: "#fff" }} />
                </Box>
            ))}
            </Box>
        </Box>
        </Box>
    );
};
export default CashBackProcess;